import { DataBean } from "../DataBean";

export class MovementsForAccountant extends DataBean {


    public async updateMovementsForAccountantIDWithBusinessCore(idAccountantIDType:any,year:any,month:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_updateMovementsForAccountantIDWithBusinessCore_Number_Number_Number", [idAccountantIDType,year,month]);
    }


}